/* eslint-disable no-console */

import { register } from 'register-service-worker'

// How often to ask the browser whether a new build has been deployed.
const UPDATE_CHECK_INTERVAL = 60 * 1000

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // Was this page already under a service worker's control when it loaded?
    // On a first-ever visit it is not, and the controllerchange that follows
    // that initial install must not trigger a reload.
    const wasControlled = !!navigator.serviceWorker.controller
    let reloading = false

    // The worker is built with skipWaiting + clientsClaim, so a new build
    // activates and claims this page by itself. Claiming fires
    // 'controllerchange', and from that moment the new worker serves the new
    // assets — so this is the point at which reloading picks up the update.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!wasControlled || reloading) return
        reloading = true
        window.location.reload()
    })

    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            console.log('App is being served from cache by a service worker.')
        },
        registered(registration) {
            console.log('Service worker has been registered.')

            // A registration only checks for a new worker on navigation, so a
            // tab left open would never notice a new build. Poll instead, and
            // check again whenever the tab comes back to the foreground.
            const checkForUpdate = () => registration.update().catch(() => {})

            setInterval(checkForUpdate, UPDATE_CHECK_INTERVAL)
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') checkForUpdate()
            })
        },
        cached() {
            console.log('Content has been cached for offline use.')
        },
        updatefound() {
            console.log('New content is downloading.')
        },
        updated() {
            console.log('New content is available; reloading.')
        },
        offline() {
            console.log('No internet connection found. App is running in offline mode.')
        },
        error(error) {
            console.error('Error during service worker registration:', error)
        }
    })
}
